import type { ReactNode } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';

/**
 * Capa (banner) da loja: ocupa toda a largura da faixa e fica centralizada na
 * vertical — o que sobra acima e abaixo é cortado por igual.
 */
export function CapaLoja({
  url,
  sx,
  children,
  onClick,
}: {
  url: string;
  sx?: SxProps<Theme>;
  children?: ReactNode;
  onClick?: () => void;
}): JSX.Element {
  return (
    <Box
      onClick={onClick}
      sx={[{ position: 'relative', width: '100%', overflow: 'hidden', bgcolor: 'grey.100' }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Box
        component="img"
        src={url}
        alt=""
        sx={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
      />
      {children}
    </Box>
  );
}
